import { GenericDashboardBlurIllustration } from '@carboncopyco/illustrations';
import type { IGlobalTab } from '@carboncopyco/types/desktop';
import { AnalyticsTrackEventName, useAnalytics } from '@carboncopyco/utils';
import { MemoryRouter, Route, Routes } from 'react-router-dom';
import { useEditorPageInfo } from '../components/EditorContainer/hooks';
import GiveADemoModalExtended from '../components/GiveADemoModalExtended';
import PresentAndPreviewToolbar from '../components/PresentAndPreviewToolbar';
import { useTabFocus } from '../hooks/useTabFocus';
import { useTabManager } from '../services/TabManager';
import { ResponsiveModeContextProvider } from '../store/context/ResponsiveModeContext';

const PresenterLinkScreenRoute = ({ tab }: { tab: IGlobalTab }) => {
  const { workspaceId } = tab;
  const { asset, assetRevisionId, withGiveADemo, hidePlayLater } = tab.payload;
  const { closeGlobalTab } = useTabManager();
  const { trackEvent } = useAnalytics();
  const pageInfo = useEditorPageInfo(tab);

  let presentClicked = false;
  useTabFocus({
    tab,
    onTabIsDeactivated: () => {
      closeGlobalTab(tab.id);
    },
  });

  const imageUrl = asset?.image || asset?.assets?.[0]?.entity?.image;

  return (
    <ResponsiveModeContextProvider>
      <PresentAndPreviewToolbar
        tab={tab}
        speakerPannel={{
          isVisible: true,
          isDisabled: true,
        }}
        pageInfo={pageInfo}
      />
      <div className="flex flex-col grow relative">
        {imageUrl ? (
          <div
            className="bg-cover bg-center no-repeat blur w-screen h-screen"
            style={{
              backgroundImage: `url(${imageUrl})`,
            }}
          />
        ) : (
          <GenericDashboardBlurIllustration
            height="h-screen"
            width="w-screen"
          />
        )}
        <GiveADemoModalExtended
          workspaceId={workspaceId as string}
          withNotificationOnPresent={false}
          onBeforePresent={() => {
            presentClicked = true;
            trackEvent(AnalyticsTrackEventName.PRESENTER_LINK_CLICK_PRESENT, {
              location: 'presenter_view_deeplink',
            });
          }}
          open
          entity={asset}
          assetRevisionId={assetRevisionId}
          withGiveADemo={withGiveADemo}
          hidePlayLater={hidePlayLater}
          onClose={() => {
            if (!presentClicked) closeGlobalTab(tab.id);
          }}
        />
      </div>
    </ResponsiveModeContextProvider>
  );
};

export const PresenterLinkScreen = ({ tab }: { tab: IGlobalTab }) => (
  <MemoryRouter
    initialEntries={[`/${String(tab.organizationId)}/${tab.workspaceId}`]}
  >
    <Routes>
      <Route
        path="/:organizationId/:workspaceId"
        element={<PresenterLinkScreenRoute tab={tab} />}
      />
    </Routes>
  </MemoryRouter>
);
